import React from 'react';
import { WebhookRequestLogEntry } from 'nekst-api';
import { SimpleBlock } from 'ui-builder';

import styles from './WebhookRequestLogInfo.module.scss';
import { RequestInfo } from './RequestInfo';


export default function WebhookRequestLogInfo(
  props: {
    request: WebhookRequestLogEntry,
  }
) {
  const formatHeaders = (headers: Record<string, string[]>) => {
    return Object.entries(headers).map(([key, values]) => {
      return `${key}: ${values.join(', ')}`;
    }).join('\n');
  }

  const formatServerResponse = (serverResponse: any) => {
    const parts = [];

    if (serverResponse.status) {
      parts.push(`Response Status Code: ${serverResponse.status}`);
    }

    if (serverResponse.headers) {
      parts.push(`Response Headers:\n ${formatHeaders(serverResponse.headers)}`);
    }

    if (serverResponse.body) {
      parts.push(serverResponse.body);
    }

    return parts.join('\n\n');
  }

  return (
    <SimpleBlock className={styles.fieldsList}>
      <SimpleBlock>
        POST {props.request.url}
      </SimpleBlock>
      <RequestInfo label="Request Payload:" text={JSON.stringify(props.request.payload)} />
      <RequestInfo label="Response:" text={formatServerResponse(props.request.serverResponse)} />
    </SimpleBlock>
  );
}
